<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 48.25 18.853">
    <g id="Convertible" transform="translate(0)">
      <path id="Path_86912" data-name="Path 86912"
        d="M29.788,626.778a4.259,4.259,0,1,0-4.259-4.259,4.264,4.264,0,0,0,4.259,4.259m0-6.591a2.332,2.332,0,1,1-2.332,2.332,2.335,2.335,0,0,1,2.332-2.332"
        transform="translate(9.956 -607.925)" :fill="themeColor" />
      <path id="Path_86913" data-name="Path 86913"
        d="M205.021,626.778a4.259,4.259,0,1,0-4.259-4.259,4.264,4.264,0,0,0,4.259,4.259m0-6.591a2.332,2.332,0,1,1-2.332,2.332,2.335,2.335,0,0,1,2.332-2.332"
        transform="translate(-194.422 -607.925)" :fill="themeColor" />
      <path id="Path_86914" data-name="Path 86914"
        d="M263.763,598.09a.963.963,0,0,0,.114-1.92,3,3,0,0,1-2.235-2.287l1.85-4.48a.963.963,0,1,0-1.781-.736l-1.973,4.779a.956.956,0,0,0-.049.584,4.921,4.921,0,0,0,3.958,4.053,1,1,0,0,0,.116.007"
        transform="translate(-259.665 -582.758)" :fill="themeColor" />
      <path id="Path_86915" data-name="Path 86915"
        d="M106.506,562.975a.964.964,0,0,0,.389-1.846c-1.943-.854-9.364-4.85-9.438-4.891a.964.964,0,0,0-.915,1.7c.308.166,7.563,4.074,9.577,4.958a.958.958,0,0,0,.387.082"
        transform="translate(-75.194 -556.123)" :fill="themeColor" />
      <path id="Path_86916" data-name="Path 86916"
        d="M84.407,638.647h16.23a.964.964,0,1,0,0-1.927H84.407a.964.964,0,1,0,0,1.927"
        transform="translate(-67.229 -623.315)" :fill="themeColor" />
      <path id="Path_86917" data-name="Path 86917"
        d="M116.746,582.666a.964.964,0,0,0,0-1.927l-17.687-.068-2.814-1.435a.963.963,0,0,0-.592-.093l-9.163,1.487a.964.964,0,1,0,.309,1.9l8.852-1.436,2.738,1.4a.959.959,0,0,0,.434.105l17.917.069Z"
        transform="translate(-83.711 -575.303)" :fill="themeColor" />
      <path id="Path_86918" data-name="Path 86918"
        d="M16.936,596.14l.074,0A.964.964,0,0,0,17.9,595.1c-.006-.07-.133-1.718-.317-2.622-.045-.227-.151-.746-1.537-1.522a10.827,10.827,0,0,0-2.011-2.454c-1.185-.833-3.837-1.259-7.748-1.812a35.543,35.543,0,0,1-5-.907.964.964,0,1,0-.64,1.818,35.034,35.034,0,0,0,5.371,1c2.539.359,6.015.851,6.909,1.48a11.231,11.231,0,0,1,1.625,2.119.971.971,0,0,0,.367.34,5.824,5.824,0,0,1,.812.515c.117.689.217,1.793.248,2.2a.963.963,0,0,0,.96.89"
        transform="translate(30.35 -580.808)" :fill="themeColor" />
      <path id="Path_86919" data-name="Path 86919"
        d="M269.146,586.574a.964.964,0,0,0,.392-1.845l-1.54-.682a.964.964,0,0,0-.781,1.763l1.54.682a.964.964,0,0,0,.389.083"
        transform="translate(-266.21 -579.333)" :fill="themeColor" />
    </g>
  </svg>
</template>


<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
